var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsArrowRightRoundedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:arrow-right-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.00933 8.80435C2.48248 9.49275 2.36436 10.2804 2.65496 11.1674C2.94556 12.0543 3.46575 12.4986 4.21553 12.5L12.7837 12.5C13.5324 12.5 14.0526 12.0558 14.3443 11.1674C14.636 10.279 14.5179 9.4913 13.9899 8.80435L9.66422 3.15217C9.49785 2.93478 9.31762 2.77174 9.12351 2.66305C8.92941 2.55435 8.72145 2.5 8.49962 2.5C8.27779 2.5 8.06982 2.55435 7.87572 2.66305C7.68162 2.77174 7.50138 2.93478 7.33501 3.15217L3.00933 8.80435Z",
    fill: "#29CA1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsArrowRightRoundedGreen);
export default __webpack_public_path__ + "static/media/material-symbols_arrow-right-rounded_green.3e829b37a14fccba80fa6137d1aa0b98.svg";
export { ForwardRef as ReactComponent };